import React, {
  useRef,
  RefObject,
} from 'react';
import isNil from 'lodash/isNil';
import dayjs, {
  Dayjs,
} from 'utils/dayjs';
import {
  useUserSettings,
} from 'core/hooks';
import FilterProvider from 'core/Filters/context';
import {
  AppointmentsFilter,
} from 'core/Filters/types';
import useUrlSyncState from 'pages/Dashboard/hooks/useUrlSyncState';
import usePersistentState from 'pages/Dashboard/hooks/usePersistentState';
import {
  Appointment,
} from 'pages/Dashboard/pages/Appointments/pages/List/types/event';
import AppointmentList from 'pages/Dashboard/pages/Appointments/pages/List/components/AppointmentList';
import {
  CalendarViewType,
  DATE_UNIT_BY_VIEW_TYPE,
} from 'pages/Dashboard/pages/Appointments/pages/List/utils/helper';

export default function List() {
  const [viewType, setViewType] = usePersistentState<CalendarViewType>(
    'Weekly',
    'appointment.view_type',
  );

  const defaultViewTypeDate = dayjs().startOf(DATE_UNIT_BY_VIEW_TYPE[viewType]);
  const [date, setDate] = useUrlSyncState<Dayjs>(
    defaultViewTypeDate,
    'date',
    (state: Dayjs) => state.format('YYYY-MM-DD'),
    (query: string) => (query ? dayjs(query) : defaultViewTypeDate),
  );
  const filterSlotRef = useRef<HTMLDivElement>(null!) as RefObject<HTMLDivElement>;
  const { settings } = useUserSettings();

  const onDateChange = (date: Dayjs) => {
    if (dayjs?.isDayjs(date) && date?.isValid()) {
      setDate(date);
    } else if (!isNil(date)) {
      console.warn('[AppointmentsList] Ignoring unexpected date value.', date);
    }
  };

  return (
    <FilterProvider<AppointmentsFilter, Appointment>
      objectType="appointment"
      controlClassName="settings-button-select w-full"
      defaultValues={settings?.appointmentFilters ?? {}}
      filtersSlot={filterSlotRef.current}
      dataParams={[date, viewType]}
    >
      <AppointmentList
        ref={filterSlotRef}
        date={date}
        setDate={onDateChange}
        viewType={viewType}
        setViewType={setViewType}
      />
    </FilterProvider>
  );
}
